import firebase from 'firebase/compat/app';

const CheckUserCredentials = {
  install(app, options) {
    const router = options.router;

    firebase.auth().onAuthStateChanged((user) => {
      if (
        !user &&
        '/register' !== router.currentRoute.value.path &&
        '/login' !== router.currentRoute.value.path &&
        '/forgotten' !== router.currentRoute.value.path &&
        '/sign' !== router.currentRoute.value.path.substr(0, 5)
      ) {
        window.localStorage.clear();
        router.push('/login');
      }
    });
  }
};


export default CheckUserCredentials;
